<template>
    <div class="home">
        <!-- Main jumbotron for a primary marketing message or call to action -->
        <div class="jumbotron">
            <div class="container">
                <h1>🚀 MUMASH</h1>
                <b-badge variant="success" class="m-1">connected</b-badge>
                <p>
                    This is a template for a simple marketing or informational
                    website. It includes a large callout called a jumbotron and
                    three supporting pieces of content. Use it as a starting
                    point to create something more unique.
                </p>
            </div>
        </div>

        <div class="container">
            <!-- Example row of columns -->
            <div class="row">
                <div class="col-md-4">
                    <b-card
                        no-body
                        style="max-width: 20rem;"
                        img-src="https://images.unsplash.com/photo-1586979816990-1819efcad0de?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1950&q=80"
                        img-alt="Image"
                        img-top
                    >
                        <b-card-body>
                            <b-card-title>Queue</b-card-title>
                            <b-card-text>
                                <small class="text-muted">🕑 {{ queue.updatedAt }}</small>
                            </b-card-text>
                        </b-card-body>

                        <b-list-group flush>
                            <b-list-group-item>
                                <div class="d-flex justify-content-between">
                                    <span>
                                        <strong>Jobs pending</strong>
                                        <br />
                                    </span>
                                    <span>
                                        <b-badge pill variant="dark">{{ queue.pending.data.length }}</b-badge>
                                    </span>
                                </div>
                            </b-list-group-item>
                            <b-list-group-item>
                                <div class="d-flex justify-content-between">
                                    <span>
                                        <strong>Jobs running</strong>
                                        <br />
                                    </span>
                                    <span>
                                        <b-badge
                                            pill
                                            variant="success"
                                        >{{ queue.running.data.length }}</b-badge>
                                    </span>
                                </div>
                            </b-list-group-item>
                            <b-list-group-item>
                                <div class="d-flex justify-content-between align-items-center">
                                    <span>
                                        <strong>Jobs failed</strong>
                                        <br />
                                        <small class="text-muted">last 24 hours</small>
                                    </span>
                                    <span>
                                        <b-badge
                                            pill
                                            variant="danger"
                                        >{{ queue.failed.data.length }}</b-badge>
                                    </span>
                                </div>
                            </b-list-group-item>
                            <b-list-group-item>
                                <div class="d-flex justify-content-between align-items-center">
                                    <span>
                                        <strong>Jobs increase</strong>
                                        <br />
                                        <small class="text-muted">updated every minute</small>
                                    </span>
                                    <span>
                                        <b-badge
                                            :variant="queue.increase.variant"
                                        >{{ queue.increase.data }}</b-badge>
                                    </span>
                                </div>
                            </b-list-group-item>
                        </b-list-group>
                    </b-card>
                </div>
                <div class="col-md-4">
                    <b-card
                        no-body
                        style="max-width: 20rem;"
                        img-src="https://images.unsplash.com/photo-1517420704952-d9f39e95b43e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1350&q=80"
                        img-alt="Image"
                        img-top
                    >
                        <b-card-body>
                            <b-card-title>E2E-Test related songs</b-card-title>
                            <b-card-text>
                                <small class="text-muted">🕑 {{ e2e.updatedAt }}</small>
                            </b-card-text>
                        </b-card-body>

                        <b-list-group flush>
                            <b-list-group-item>
                                <div class="d-flex justify-content-between align-items-center">
                                    <span>
                                        Recent test ({{ e2e.latest.data.id }})
                                        <br />
                                        <small>
                                            started
                                            {{ e2e.latest.dt.fromNow() }}
                                        </small>
                                    </span>
                                    <span>
                                        <b-badge
                                            pill
                                            variant="dark"
                                            v-if="
                                                e2e.latest.data.completed_at ==
                                                    null
                                            "
                                        >running</b-badge>
                                        <b-badge
                                            pill
                                            variant="success"
                                            v-if="
                                                e2e.latest.data.completed_at !=
                                                    null
                                            "
                                        >passed</b-badge>
                                    </span>
                                </div>
                            </b-list-group-item>
                            <b-list-group-item>
                                <div class="d-flex justify-content-between align-items-center">
                                    <span>
                                        Tests passed
                                        <br />
                                        <small>last 24 hours</small>
                                    </span>
                                    <b-badge pill variant="success">
                                        {{
                                        e2e.passed.data.length
                                        }}
                                    </b-badge>
                                </div>
                            </b-list-group-item>
                            <b-list-group-item>
                                <div class="d-flex justify-content-between align-items-center">
                                    <span>
                                        Tests failed
                                        <br />
                                        <small>last 24 hours</small>
                                    </span>
                                    <b-badge pill variant="danger">
                                        {{
                                        e2e.failed.data.length
                                        }}
                                    </b-badge>
                                </div>
                            </b-list-group-item>
                        </b-list-group>
                    </b-card>
                </div>
                <div class="col-md-4"></div>
            </div>
            <hr />
        </div>
        <b-table striped hover :items="queue.all.data" :fields="fields"></b-table>
    </div>
</template>

<script>
// @ is an alias to /src
//import HelloWorld from '@/components/HelloWorld.vue'

import moment from 'moment'
export default {
    name: 'home',
    components: {},
    data() {
        return {
            fields: ['id', 'queue', 'displayName', 'attempts', 'created_at'],
            polling: null,
            queue: {
                updatedAt: moment(),
                running: {
                    data: []
                },
                pending: {
                    data: []
                },
                failed: {
                    data: []
                },
                increase: {
                    data: []
                },
                all: {
                    data: []
                }
            },
            e2e: {
                failed: {
                    data: []
                },
                passed: {
                    data: []
                },
                latest: {
                    data: [],
                    dt: moment()
                }
            }
        }
    },
    methods: {
        pollData() {
            this.polling = setInterval(() => {
                this.$store
                    .dispatch('retrieveStatus')
                    .then(data => {
                        this.queue.running.data = data['queue']['running']
                        this.queue.pending.data = data['queue']['pending']
                        this.queue.failed.data = data['queue']['failed']
                        this.queue.increase.data = data['queue']['increase']

                        if (this.queue.increase.data < 1) {
                            this.queue.increase.variant = 'success'
                        } else {
                            this.queue.increase.variant = 'danger'
                        }

                        this.queue.all.data = data['queue']['all']
                        this.queue.updatedAt = moment()

                        this.e2e.failed.data = data['e2e']['failed']
                        this.e2e.passed.data = data['e2e']['passed']
                        this.e2e.latest.data = data['e2e']['latest']
                        this.e2e.latest.dt = moment(
                            data['e2e']['latest'].created_at,
                            'YYYY-MM-DD HH:mm:ss'
                        )
                        this.e2e.updatedAt = moment()
                    })
                    .catch(err => {
                        console.log(err)
                    })
            }, 1010)
        }
    },
    beforeDestroy() {
        clearInterval(this.polling)
    },
    created() {
        this.pollData()
    }
}
</script>
